// RigSentinel Calc - shared helpers used by every category module.
// All math is pure JavaScript - deterministic, no AI, no randomness.

export const round = (v, d = 4) => {
  if (!isFinite(v)) return v;
  const f = Math.pow(10, d);
  return Math.round(v * f) / f;
};

export const num = (v, name) => {
  if (v === "" || v === null || v === undefined) throw new Error(`Missing input: ${name}`);
  const n = Number(v);
  if (Number.isNaN(n)) throw new Error(`Invalid number for ${name}`);
  return n;
};

export const positive = (n, name) => {
  if (n <= 0) throw new Error(`${name} must be greater than zero`);
  return n;
};

export const toRad = (d) => (d * Math.PI) / 180;

// Placeholder: any calc whose fn === comingSoonFn renders a Coming Soon banner.
export function comingSoonFn() {
  throw new Error("Advanced — Coming Soon. This calculator depends on company-specific models and is being prepared for a future release.");
}
